/**
 * Web entry. OWNER: web-frontend-engineer.
 *
 * The ONLY import of the generated stylesheet in the whole app. Every value in
 * every component comes from a custom property or a `.type-role-*` class
 * declared in it. A hex, a px, an ms or a cubic-bezier in a component is a
 * defect, not a style choice (BUILD_PIPELINE §7 gate G1).
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@pt/tokens/tokens.css';
import './app/app.css';
import './components/components.css';
import { App } from './app/App.tsx';

const root = document.getElementById('root');
if (root === null) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
